import { Form, Button, Col, Row, Table, Alert, InputGroup } from 'react-bootstrap';
import Card from 'react-bootstrap/Card';
import React, { useState, useRef, useEffect } from 'react';
import { FaEdit, FaTrash } from 'react-icons/fa';

import QualitativeModal from './qualitativeModal';
import QuantitativeModal from './quantitativeModal';
import PerformanceDataModal from './performanceDataModal';
import { SpinnerModal, blockInvalidChar, generateYears, getFiscalYear } from '../Util';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import axios from "axios";
import { Link, useParams, useSearchParams } from "react-router-dom";
import ConfirmationModal from '../../core/ConfirmationModal';

export default function Performance() {

    const years = generateYears(2020, new Date().getFullYear());
    const PERFORMANCE_BASE_URL = process.env.REACT_APP_PERFORMANCE_BASE_URL;
    const PERFORMANCE_POST = process.env.REACT_APP_PERFORMANCE_POST;
    const PERFORMANCE_PUT = process.env.REACT_APP_PERFORMANCE_PUT;
    const PERFORMANCE_GET_ID = process.env.REACT_APP_PERFORMANCE_GET_ID;

    const [userName, setUserName] = useState(null);
    const [userRole, setUserRole] = useState(null);

    useEffect(() => {
        const storedUser = sessionStorage.getItem('user');
        if (storedUser) {
            const { firstName, lastName, role } = JSON.parse(storedUser);
            setUserName(`${firstName} ${lastName}`.toUpperCase());
            setUserRole(role);
        }
    }, []);
    const data = {

        type: "PERFORMANCE",
        createdBy: "", // user
        updateddBy: "", // updated user
        status: "",
        createdDate: "",
        updatedDate: "",
        siteName: "",
        year: "",
        month: "",
        fiscalYear: "",
        performanceData: [], //  qualitative, quantitative and fiscal
        personnel: {
            noOfPhmcStaff: "",
            noOfAssociateStaff: "",
            noOfVolunteers: ""
        },
        remarks: "",
        acknowledge: false
    }
    const [formId, setFormId] = useState();

    const saveSchema = Yup.object({
        siteName: Yup.string().required('Site Name is required!'),
        year: Yup.string().required('Year is required!'),
        month: Yup.string().required('Month is required!')
    });

    const performanceSchema = Yup.object({
        siteName: Yup.string().required('Site Name is required!'),
        year: Yup.string().required('Year is required!'),
        month: Yup.string().required('Month is required!'),
        personnel: Yup.object({
            noOfPhmcStaff: Yup.number()
                .required('Number of PHMC staffs are required!')
                .positive('Positive numbers only allowed'),
            noOfAssociateStaff: Yup.number().required('Number of Associate Staffs are required!').positive('Positive numbers only allowed'),
            noOfVolunteers: Yup.number().required('Number of Volunteers are required!').positive('Positive numbers only allowed')
        }),

        acknowledge: Yup.boolean().oneOf([true], 'Verify all the data and click ')

    });
    const formDataRef = useRef(null);
    const performanceForm = useFormik({
        initialValues: data,
        initialTouched: {
            siteName: true,
            year: true,
            month: true,
            personnel: {
                noOfPhmcStaff: true,
                noOfAssociateStaff: true,
                noOfVolunteers: true
            },
            remarks: true,
            acknowledge: true
        },
        validationSchema: performanceSchema,
        onSubmit: (values) => {
            console.log(values);
        }
    });



    const updateStatus = (action) => {
        if (action === 'save') {
            performanceForm.values.status = 'DRAFT';
            console.log('Saved Status:' + performanceForm.values.status);
        } else if (action === 'submit') {
            performanceForm.values.status = 'SUBMITTED';
        }
    }
    const [showValidationError, setShowValidationError] = useState(false);
    const [successId, setSuccessId] = useState('');
    const [show, setShow] = useState(false);
    // Alert message after save/submit
    const [alertHeading, setAlertHeading] = useState('');
    const [alertMessage, setAlertMessage] = useState('');
    const [pagePath, setPagePath] = useState('');

    const [saveShow, setSaveShow] = useState(false);
    const handleSaveClose = () => setSaveShow(false);
    const handleSaveShow = () => setSaveShow(true);

    const [submitShow, setSubmitShow] = useState(false);
    const handleSubmitClose = () => setSubmitShow(false);
    const handleSubmitShow = () => setSubmitShow(true);
    const handleSubmission = (e) => {
        const action = e.target.name;
        console.log(action);
        // closing Modal
        if (action === 'submit') {
            handleSubmitClose();
        }
        if (action === 'save') {
            handleSaveClose();
        }
        setSpinnerShow(true);

        const datetime = new Date().toISOString();
        performanceForm.values.updatedDate = datetime;
        performanceForm.values.updateddBy = userName ? userName : ""; //user
        // Update FiscalYear
        performanceForm.values.fiscalYear = getFiscalYear(performanceForm.values.year, performanceForm.values.month);
        // updateStatus(action);
        // when trying to save again or submit after save
        if (performanceForm.values.status === 'DRAFT') {
            updateStatus(action);
            // Turn-on the Spinner
            // setSpinner(true);
            console.log('Update:' + performanceForm.values);
            // Call REST API to update the data
            const url = `${PERFORMANCE_BASE_URL}${id}${PERFORMANCE_PUT}`;

            if (id)
                axios.put(url, performanceForm.values)
                    .then((response) => {
                        console.log(response.status, response.data);
                        setSuccessId(response.data._id);
                        setShow(true);
                        performanceForm.resetForm();
                        setShowValidationError(false);
                        // Turn off spinner
                        setSpinnerShow(false);

                        if (action === 'save') {
                            setAlertHeading('Saved');
                            setAlertMessage(`Performance Record has been saved! `);
                            setPagePath("/performance");
                        } else if (action === 'submit') {
                            setAlertHeading('Submitted');
                            setAlertMessage('PHMC will review your performance submission record.');
                            setPagePath("/performance-response");
                        }


                    }).catch((error) => {
                        console.log(error);
                        setShow(false);
                        setSuccessId('');
                        setAlertHeading('Error');
                        setAlertMessage('Something wrong, Please try again!');
                        // Turn off spinner
                        setSpinnerShow(false);
                    });

        } else {
            updateStatus(action);
            console.log('Save: ' + performanceForm.values);
            performanceForm.values.createdDate = datetime;
            performanceForm.values.createdBy = userName ? userName : "";

            // Turn-on the Spinner
            // setSpinner(true);
            // Call REST API to store the data
            const url = `${PERFORMANCE_BASE_URL}${PERFORMANCE_POST}`;
            axios.post(url, performanceForm.values)
                .then((response) => {
                    console.log(response.status, response.data);
                    setSuccessId(response.data._id);
                    setShow(true);
                    performanceForm.resetForm();
                    setShowValidationError(false);
                    // Turn off spinner
                    setSpinnerShow(false);

                    if (action === 'save') {
                        setAlertHeading('Saved');
                        setAlertMessage(`Performance Record has been saved!`);
                        setPagePath("/performance");
                    } else if (action === 'submit') {
                        setAlertHeading('Submitted');
                        setAlertMessage(`PHMC will review your performance submission record.`);
                        setPagePath("/performance-response");
                    }


                }).catch((error) => {
                    console.log(error);
                    formData.status = "";
                    setShow(true);
                    setSuccessId('');
                    // Turn off spinner
                    setSpinnerShow(false);
                    setAlertHeading('Error');
                    setAlertMessage('Something wrong, Please try again!');
                });
        }
    }

    let { id } = useParams();
    useEffect(() => {
        const recordId = id;
        console.log(recordId);
        if (recordId) {
            setSpinnerShow(true);
            const url = `${PERFORMANCE_BASE_URL}${recordId}${PERFORMANCE_GET_ID}`;
            console.log(url);
            fetch(url)
                .then(response => response.json())
                .then(data => {
                    setFormId(data._id);
                    performanceForm.setValues(data);
                    setSpinnerShow(false);
                })
        }
    }, []);
    const handleSaveRecord = () => {
        // Validate only specific fields using saveButtonValidationSchema
        saveSchema
            .validate(performanceForm.values, { abortEarly: false })
            .then(() => {
                // If there are no validation errors, add the record
                // setFormData(performanceForm.values);
                // formDataRef.current = performanceForm.values;
                console.log('save validated!');
                handleSaveShow();
                // You can add logic here to push the values into an array or perform other actions
                // performanceForm.resetForm(); // Optionally reset the form after adding a record
            })
            .catch((errors) => {
                console.log(performanceForm.errors);
                // setShowError(true)
                // Handle validation errors
                console.error('Validation errors for Save:', errors);
                // You may want to display the errors to the user or perform other actions
            });
    }

    const [formData, setFormData] = useState(data);
    const [spinnerShow, setSpinnerShow] = useState(false);
    //Performance Data
    const [performanceDataItem, setPerformanceDataItem] = useState();
    const [performanceDataShow, setPerformanceDataShow] = useState(false);
    const handlePerformanceDataClose = () => { setPerformanceDataItem(null); console.log('data item:' + performanceDataItem); setPerformanceDataShow(false); }
    const handlePerformanceDataShow = () => { setPerformanceDataShow(true); }
    const addPerformanceData = () => { setPerformanceDataItem(null); console.log('add data item:' + performanceDataItem); handlePerformanceDataShow(); }
    const [performanceData, setPerformanceData] = useState([]);

    const handlePerformanceData = (qualData) => {
        console.log('save performance data ');
        handlePerformanceDataClose();
        setPerformanceData((prevData) => [...prevData, qualData]);
        performanceForm.setFieldValue('performanceData', [...performanceForm.values.performanceData, qualData])

    }

    const handlePerformanceDataItem = (data) => {
        setPerformanceDataItem(data);
        handlePerformanceDataShow();
    }


    return (
        <>

            <span ><b>Performance Data</b> </span>
            {saveShow &&
                <ConfirmationModal action={'save'} show={saveShow} onClose={handleSaveClose} onSave={handleSubmission} />
            }
            {submitShow &&
                <ConfirmationModal action={'submit'} show={submitShow} onClose={handleSubmitClose} onSave={handleSubmission} />
            }
            {
                show ? (
                    <Alert variant="success" onClose={() => setShow(false)} dismissible>
                        <Alert.Heading>{alertHeading} </Alert.Heading>
                        {/* <Link reloadDocument to={{ pathname: pagePath, search: "?id=" + successId, state: successId }} >{successId}</Link> */}
                        <p>{alertMessage}  </p>
                    </Alert>

                ) : (<div />)}
            <div className="main-content">
                <Form className="main-content" noValidate >
                    <PerformanceDataModal show={performanceDataShow} onClose={handlePerformanceDataClose} onSave={handlePerformanceData} dataItem={performanceDataItem} />
                    <Row className="mb-0 main-content">
                        <Form.Group as={Col} controlId="formGridEmail" >
                            <Form.Label>SiteName</Form.Label>
                            <Form.Select defaultValue="" name="siteName" value={performanceForm.values.siteName}
                                onChange={performanceForm.handleChange}
                                onBlur={performanceForm.handleBlur}
                                isInvalid={performanceForm.touched.siteName && performanceForm.errors.siteName}>
                                <option value="">Select</option>
                                <option>ANTHRACITE HERITAGE</option>
                                <option>BRANDYWINE BATTLEFIELD</option>
                                <option>BUSHY </option>
                                <option>CONRAD W</option>
                                <option>CORNWALL</option>
                                <option>DANIEL B</option>
                                <option>DRAKE WELL</option>
                                <option>ECKLEY MINERS' VLGE</option>
                                <option>EPHRATA CLOISTER</option>
                                <option>ERIE MARITIME</option>
                                <option>FORT PITT</option>
                                <option>GRAEME </option>
                                <option>HOPE</option>
                                <option>JOSEPH P</option>
                                <option>LANDIS VALLEY</option>
                                <option>OLD ECONOMY</option>
                                <option>PENNSBURY</option>
                                <option>PA LUMBER MUSEUM</option>
                                <option>PA MILITARY MUSEUM</option>
                                <option>RAILROAD MUSEUM</option>
                                <option>SOMERSET</option>
                            </Form.Select>
                            <Form.Control.Feedback type="invalid">
                                {performanceForm.touched.siteName && performanceForm.errors.siteName}
                            </Form.Control.Feedback>
                        </Form.Group>

                        <Form.Group as={Col} controlId="formGridPassword">
                            <Form.Label>Year</Form.Label>
                            <Form.Select name="year" value={performanceForm.values.year}
                                onChange={performanceForm.handleChange}
                                onBlur={performanceForm.handleBlur}
                                isInvalid={performanceForm.touched.year && performanceForm.errors.year}>
                                <option value="">Select</option>
                                {years.map(year => (
                                    <option key={year} value={year}>{year}</option>
                                ))}
                            </Form.Select>
                            <Form.Control.Feedback type="invalid">
                                {performanceForm.touched.year && performanceForm.errors.year}
                            </Form.Control.Feedback>
                        </Form.Group>
                        <Form.Group as={Col} controlId="formGridPassword">
                            <Form.Label>Month</Form.Label>
                            <Form.Select defaultValue="" name="month" value={performanceForm.values.month}
                                onChange={performanceForm.handleChange}
                                onBlur={performanceForm.handleBlur}
                                isInvalid={performanceForm.touched.month && performanceForm.errors.month}>
                                <option value="">Select</option>
                                <option>JANUARY</option>
                                <option>FEBRAURY</option>
                                <option>MARCH</option>
                                <option>APRIL</option>
                                <option>MAY</option>
                                <option>JUNE</option>
                                <option>JULY</option>
                                <option>AUGUST</option>
                                <option>SEPTEMBER</option>
                                <option>OCTOBER</option>
                                <option>NOVEMBER</option>
                                <option>DECEMBER</option>
                            </Form.Select>
                            <Form.Control.Feedback type="invalid">
                                {performanceForm.touched.month && performanceForm.errors.month}
                            </Form.Control.Feedback>
                        </Form.Group>
                    </Row>
                    {/* Performance Data  */}
                    <Row className="mb-0 main-content" >
                        <Col>
                            <Card>
                                <Card.Body>
                                    <Card.Title>Performance Data</Card.Title>
                                    <Form.Group>
                                        <Form.Label>Enter Qualitative, Quantitative and Fiscal Data by clicking the button</Form.Label>
                                    </Form.Group>
                                    <Button variant="primary" onClick={addPerformanceData}> Add Performance Data</Button >

                                    <Row className="mb-3 main-content" >
                                        <Table striped bordered hover variant="light" responsive="md">
                                            <thead>
                                                <tr>
                                                    <th>Program Category</th>
                                                    <th>Program Type</th>
                                                    <th>Program Name</th>
                                                    <th>Program Date</th>
                                                    <th>Target Audiences</th>
                                                    <th>Event Type</th>
                                                    <th>Event Location</th>
                                                    <th>Location of Attendees</th>
                                                    <th>Net Revenue</th>
                                                    <th>Action</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {performanceForm.values.performanceData.map((item, index) => (
                                                    <tr key={index}>
                                                        <td>{item.qualitative.programCategory}</td>
                                                        <td>{item.qualitative.programType}</td>
                                                        <td>{item.qualitative.programName}</td>
                                                        <td>{item.qualitative.programDate}</td>
                                                        <td>{item.quantitative.targetAudiences}</td>
                                                        <td>{item.quantitative.virtualOrInPerson}</td>
                                                        <td>{item.quantitative.onsiteOrOffsite}</td>
                                                        <td>{item.quantitative.countyHeld}</td>
                                                        <td>{item.netRevenue}</td>
                                                        <td ><Button variant="transparent" onClick={() => handlePerformanceDataItem(item)}> <FaEdit /></Button>
                                                            <Button variant="transparent" > <FaTrash /></Button></td>
                                                    </tr>
                                                ))}

                                            </tbody>
                                        </Table>
                                    </Row>
                                </Card.Body>
                            </Card>
                        </Col>
                    </Row>

                    {/* Personnel */}
                    <Row className="mb-3 main-content">
                        <Col>
                            <Card>
                                <Card.Body>
                                    <Card.Title>Personnel</Card.Title>
                                    <Row className="mb-3 main-content" >
                                        <Form.Group as={Col} controlId="noOfPhmcStaff">
                                            <Form.Label>No. of PHMC staff needed</Form.Label>
                                            <Form.Control type="number" name="personnel.noOfPhmcStaff" value={performanceForm.values.personnel.noOfPhmcStaff}
                                                onChange={performanceForm.handleChange}
                                                isInvalid={performanceForm.touched.personnel?.noOfPhmcStaff && performanceForm.errors.personnel?.noOfPhmcStaff} />
                                            <Form.Control.Feedback type="invalid">
                                                {performanceForm.touched.personnel?.noOfPhmcStaff && performanceForm.errors.personnel?.noOfPhmcStaff}
                                            </Form.Control.Feedback>
                                        </Form.Group>
                                        <Form.Group as={Col} controlId="noOfAssociateStaff">
                                            <Form.Label>No. of Associate staff needed</Form.Label>
                                            <Form.Control type="number" name="personnel.noOfAssociateStaff" value={performanceForm.values.personnel.noOfAssociateStaff}
                                                onChange={performanceForm.handleChange}
                                                isInvalid={performanceForm.touched.personnel?.noOfAssociateStaff && performanceForm.errors.personnel?.noOfAssociateStaff} />
                                            <Form.Control.Feedback type="invalid">
                                                {performanceForm.touched.personnel?.noOfAssociateStaff && performanceForm.errors.personnel?.noOfAssociateStaff}
                                            </Form.Control.Feedback>
                                        </Form.Group>
                                        <Form.Group as={Col} controlId="noOfVolunteers">
                                            <Form.Label>No. of Volunteers needed</Form.Label>
                                            {/* <Form.Control type="number" name="personnel.noOfVolunteers" value={formData.personnel.noOfVolunteers} onChange={handleInputChange} /> */}
                                            <Form.Control type="number" name="personnel.noOfVolunteers"
                                                value={performanceForm.values.personnel.noOfVolunteers}
                                                onChange={performanceForm.handleChange}
                                                onBlur={performanceForm.handleChange}
                                                isInvalid={performanceForm.touched.personnel?.noOfVolunteers && performanceForm.errors.personnel?.noOfVolunteers} />
                                            <Form.Control.Feedback type="invalid">
                                                {performanceForm.touched.personnel?.noOfVolunteers && performanceForm.errors.personnel?.noOfVolunteers}
                                            </Form.Control.Feedback>
                                        </Form.Group>
                                        <Col />
                                    </Row>
                                </Card.Body>
                            </Card>
                        </Col>

                    </Row>
                    <Row className="mb-0 main-content">
                        <Col>
                            <Card>

                                <Card.Body>
                                    <Card.Title>Remarks</Card.Title>
                                    <Form.Group as={Col} controlId="remarks">
                                        <InputGroup>
                                            <Form.Control as="textarea" aria-label="Remarks" required name="remarks" value={performanceForm.values.remarks} onChange={performanceForm.handleChange} />
                                        </InputGroup>
                                    </Form.Group>
                                </Card.Body>
                            </Card>
                        </Col>

                    </Row>
                    <Row className="mb-0 main-content">
                        <Col>
                            <Card>
                                <Card.Body>
                                    <Form.Check aria-label="Did you verify all the data?" name="acknowledge" value={performanceForm.values.acknowledge}
                                        checked={performanceForm.values.acknowledge}
                                        onChange={performanceForm.handleChange}
                                        label="Did you verify all the data?"
                                        isInvalid={performanceForm.touched.acknowledge && performanceForm.errors.acknowledge} />
                                    <Form.Control.Feedback type="invalid">
                                        {performanceForm.touched.acknowledge && performanceForm.errors.acknowledge}
                                    </Form.Control.Feedback>
                                </Card.Body>
                            </Card>
                        </Col>
                    </Row>
                    {userRole && userRole !== 'OBSERVER' &&
                        <Row className="mb-3 main-content">

                            <Col>
                                <Row className="mb-3 submit">
                                    <Col>
                                        <Button variant="secondary" onClick={performanceForm.handleReset}>
                                            Reset
                                        </Button>

                                        <Button variant="primary" className="m-1" name="save" disabled={!performanceForm.dirty} onClick={handleSaveRecord}>
                                            Save
                                        </Button>

                                        <Button variant="primary" name="submit" disabled={!performanceForm.dirty || !performanceForm.isValid} onClick={handleSubmitShow}>
                                            Submit
                                        </Button>

                                    </Col>
                                </Row>
                            </Col>


                            <Col />
                            <Col />
                            <Col />
                        </Row>
                    }
                    <SpinnerModal show={spinnerShow} onHide={() => setSpinnerShow(false)} />
                </Form>
            </div >
        </>
    );

}